import { render, staticRenderFns } from "./checkJoinArbitration.vue?vue&type=template&id=4051b238&scoped=true&"
import script from "./checkJoinArbitration.vue?vue&type=script&lang=js&"
export * from "./checkJoinArbitration.vue?vue&type=script&lang=js&"
import style0 from "./checkJoinArbitration.vue?vue&type=style&index=0&id=4051b238&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4051b238",
  null
  
)

export default component.exports